import React from "react";
import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { Trans } from "react-i18next";
import i18n from '../../../i18n';

import {
  Dialog,
  Spinner,
  Callout
} from "@blueprintjs/core";

import LineChart from "../../Charts/LineChart";


export default class EventCounterEvolution extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: undefined,
      labels: undefined
    };
  }

  render() {
    return (
      <Dialog
        title={i18n.t("evolution of the key value")}
        isOpen={this.props.open}
        style={{ transition: 'none', width: "90%" }}
        onClose={() => this.props.onClose()}
        onOpening={() =>
          authenticatedGetFetch('/activity/keyvalueEvolution?' + this.props.urlsearchparams + "&id=" + this.props.data.info.id,
            (response) => {
              this.setState({
                loading: false,
                data: response['data'],
                labels: response['labels']
              });
            })}
      >
        <div class="flexbox-center">
        {this.state.data !== undefined
          ? (this.state.data.length > 0
            ? <LineChart title={this.props.data.info.title} large={true} format="date" data={this.state.data} labels={this.state.labels} />
            : <Callout intent="primary"><Trans>no event registered during the selected period</Trans></Callout>)
          : <Spinner />}
        </div>
      </Dialog>
    );
  }
}